import { ReportCategory } from '../../AnalyticsHub/utils/reportCatalog';
import { ReportStatus } from '../../../store/slices/reportingConfigurationSlice';

export type SortDirection = 'asc' | 'desc';

export type SortKey =
  | 'name'
  | 'primaryTag'
  | 'secondaryTags'
  | 'kpiTags'
  | 'status'
  | 'description'
  | 'link'
  | 'icon';

export type FilterKey = 'name' | 'primaryTag' | 'secondaryTags' | 'kpiTags' | 'status' | 'description' | 'link';

export interface ColumnFilters {
  nameQuery: string;
  descriptionQuery: string;
  linkQuery: string;
  primaryTags: ReportCategory[];
  secondaryTags: ReportCategory[];
  kpiTags: string[];
  statuses: ReportStatus[];
}

export interface FilterPopoverPosition {
  top: number;
  left: number;
}

export interface ReportingTableColumn {
  key: SortKey;
  label: string;
  width: number;
  filterable: boolean;
}

export const REPORTING_PRIMARY_TAG_OPTIONS: ReportCategory[] = [
  'Safety',
  'People',
  'Accuracy',
  'Reliability',
  'Cost',
  'Navigator',
];

export const REPORTING_ICON_OPTIONS: string[] = [
  'analytics',
  'bar-chart',
  'insert-chart',
  'show-chart',
  'pie-chart',
  'timeline',
  'trending-up',
  'trending-down',
  'dashboard',
  'assessment',
  'insights',
  'query-stats',
  'monitoring',
  'description',
  'summarize',
  'article',
  'table-chart',
  'view-list',
  'fact-check',
  'checklist',
  'inventory',
  'inventory-2',
  'warehouse',
  'local-shipping',
  'route',
  'map',
  'location-on',
  'place',
  'store',
  'attach-money',
  'payments',
  'savings',
  'account-balance',
  'groups',
  'person',
  'supervisor-account',
  'engineering',
  'build',
  'settings',
  'tune',
  'rule',
  'bolt',
  'warning',
  'error-outline',
  'verified',
  'security',
  'shield',
  'task-alt',
  'check-circle',
  'flag',
  'star',
  'confirmation-number',
];

export const REPORTING_TABLE_COLUMNS: ReportingTableColumn[] = [
  { key: 'icon', label: 'Icon', width: 72, filterable: false },
  { key: 'name', label: 'Report Name', width: 230, filterable: true },
  { key: 'primaryTag', label: 'Primary Tag', width: 150, filterable: true },
  { key: 'secondaryTags', label: 'Secondary Tag(s)', width: 230, filterable: true },
  { key: 'kpiTags', label: 'KPI Tag(s)', width: 250, filterable: true },
  { key: 'status', label: 'Status', width: 120, filterable: true },
  { key: 'description', label: 'Description', width: 320, filterable: true },
  { key: 'link', label: 'Link', width: 230, filterable: true },
];

export const createReportingInitialColumnFilters = (): ColumnFilters => ({
  nameQuery: '',
  descriptionQuery: '',
  linkQuery: '',
  primaryTags: [],
  secondaryTags: [],
  kpiTags: [],
  statuses: [],
});

export const REPORTING_INITIAL_COLUMN_FILTERS: ColumnFilters = createReportingInitialColumnFilters();
